


function my_test_becrop_please_work(a){

    // if(a && a.b) a.b++;
    return "Yeah!!!!!!!!!!"  + "!!!!!!!";

}

window.my_test_becrop_please_work = my_test_becrop_please_work;